import {useAuth} from 'react-oidc-context'
import {getCredsFromOidcUser} from './auth.utils'

export const useCurrentUser = () => {
	const { user } = useAuth()

	return getCredsFromOidcUser(user as any)
}
